import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ViewContainerRef,
  Input,
  ɵcreateInjector as createInjector,
  Injector,
} from '@angular/core';
import { TrackingMapsRenderService } from '../tracking-maps-render.service';
import { filter, take } from 'rxjs/operators';
import { MapDataType } from './models';

@Component({
  selector: 'lib-shipment-overview-map-container',
  templateUrl: './shipment-overview-map-container.component.html',
  styleUrls: ['./shipment-overview-map-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentOverviewMapContainerComponent {
  @Input() set mapData(mapData: MapDataType | null) {
    if (mapData) {
      this.scriptAppendSubscription(mapData);
    }
  }

  @ViewChild('container', { read: ViewContainerRef, static: true })
  mapContainerRef: ViewContainerRef;

  constructor(private trackingMapRenderService: TrackingMapsRenderService, private injector: Injector) {}

  private scriptAppendSubscription(mapData: MapDataType): void {
    this.trackingMapRenderService.isGoogleMapApiScriptAppended$.pipe(filter(Boolean), take(1)).subscribe(async () => {
      if (this.mapContainerRef) {
        const moduleRef = await import('./shipment-overview-map/shipment-overview-map.module');

        const injector = createInjector(moduleRef.ShipmentOverviewMapModule, this.injector);
        const module = injector.get(moduleRef.ShipmentOverviewMapModule);

        const componentRef = module.render(this.mapContainerRef);
        componentRef.instance.mapData = mapData;
      }
    });
  }
}
